import React, { useEffect, useState } from 'react';
import './styles.scss';
import { CircularProgress, Button } from '@mui/material';
import ShareIcon from '@mui/icons-material/Share';
import { getProfile } from 'utilities';

export const InfoCard = ({
  payable,
  userData,
  onOrderPress,
  onReOrderPress,
  onSharePress,
  loading,
  userExist,
}) => {
  console.log('user Data ===>', userData);
  const [currency, setCurrency] = useState('GBP');
  const [amount, setAmount] = useState(userExist ? 0 : 4.99);
  const [loadingPrice, setLoadingPrice] = useState(false);
  const [country, setCountry] = useState(null);

  console.log('user Data ===>', userData, currency, amount, country);

  useEffect(() => {
    const fetchDynamicPrice = async () => {
      setLoadingPrice(true);
      try {
        let selectedCurr = 'GBP';
        let amount = 4.99;

        // Use EXACTLY the same logic as your Stripe function
        const result = await fetch('/api/exchange-rates?base=GBP');
        const currencies = await result.json();

        const countryToCurrency = {
          US:'USD',GB:'GBP',PK:'PKR',IN:'INR',AU:'AUD',CA:'CAD',JP:'JPY',
          CN:'CNY',BR:'BRL',MX:'MXN',RU:'RUB',KR:'KRW',CH:'CHF',SE:'SEK',
          NO:'NOK',DK:'DKK',PL:'PLN',TR:'TRY',ZA:'ZAR',NZ:'NZD',SG:'SGD',
          HK:'HKD',MY:'MYR',ID:'IDR',TH:'THB',PH:'PHP',VN:'VND',EG:'EGP',
          SA:'SAR',AE:'AED',NG:'NGN',KE:'KES',GH:'GHS',
          DE:'EUR',FR:'EUR',IT:'EUR',ES:'EUR',NL:'EUR',BE:'EUR',PT:'EUR',
          AT:'EUR',FI:'EUR',IE:'EUR',GR:'EUR',LU:'EUR',
        };

        let myCurrencyCode = 'GBP';
        try {
          const geoRes = await fetch('https://ipinfo.io/json');
          if (geoRes.ok) {
            const geo = await geoRes.json();
            const country = (geo.country || '').trim().toUpperCase();
            myCurrencyCode = countryToCurrency[country] || 'GBP';
          }
        } catch {
          // Fallback: detect country from browser timezone
          const tzCountry = {
            'Europe/Madrid':'ES','Europe/London':'GB','Europe/Berlin':'DE',
            'Europe/Paris':'FR','Europe/Rome':'IT','Europe/Amsterdam':'NL',
            'Europe/Brussels':'BE','Europe/Lisbon':'PT','Europe/Vienna':'AT',
            'Europe/Helsinki':'FI','Europe/Dublin':'IE','Europe/Athens':'GR',
            'Europe/Luxembourg':'LU','Europe/Stockholm':'SE','Europe/Oslo':'NO',
            'Europe/Copenhagen':'DK','Europe/Warsaw':'PL','Europe/Istanbul':'TR',
            'Europe/Zurich':'CH','America/New_York':'US','America/Chicago':'US',
            'America/Denver':'US','America/Los_Angeles':'US','America/Toronto':'CA',
            'America/Vancouver':'CA','America/Sao_Paulo':'BR','America/Mexico_City':'MX',
            'Asia/Tokyo':'JP','Asia/Shanghai':'CN','Asia/Kolkata':'IN','Asia/Karachi':'PK',
            'Asia/Singapore':'SG','Asia/Hong_Kong':'HK','Asia/Kuala_Lumpur':'MY',
            'Asia/Jakarta':'ID','Asia/Bangkok':'TH','Asia/Manila':'PH','Asia/Seoul':'KR',
            'Asia/Ho_Chi_Minh':'VN','Asia/Dubai':'AE','Asia/Riyadh':'SA',
            'Australia/Sydney':'AU','Pacific/Auckland':'NZ','Africa/Johannesburg':'ZA',
            'Africa/Cairo':'EG','Africa/Lagos':'NG','Africa/Nairobi':'KE','Africa/Accra':'GH',
            'Europe/Moscow':'RU','Europe/Canary':'ES','Atlantic/Canary':'ES',
          };
          try {
            const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            const tzCountryCode = tzCountry[tz];
            if (tzCountryCode && countryToCurrency[tzCountryCode]) {
              myCurrencyCode = countryToCurrency[tzCountryCode];
            }
          } catch {}
          if (myCurrencyCode === 'GBP') {
            const lang = navigator.language || 'en-GB';
            const region = (lang.split('-')[1] || 'GB').toUpperCase();
            myCurrencyCode = countryToCurrency[region] || 'GBP';
          }
        }

        selectedCurr = myCurrencyCode;

        // Calculate amount using the exchange rate
        if (currencies.rates && currencies.rates[selectedCurr]) {
          amount = Math.ceil(currencies.rates[selectedCurr] * 4.99 * 100) / 100;
        }

        setCurrency(selectedCurr);
        setAmount(amount);
      } catch (err) {
        console.log('Error fetching currency data:', err);
        setCurrency('GBP');
        setAmount(4.99);
      } finally {
        setLoadingPrice(false);
      }
    };

    fetchDynamicPrice();
  }, []);

  function formatDateString(dateString) {
    if (dateString) {
      const [day, month, year] = dateString.split('/');
      if (!day || !month || !year) {
        return 'NA';
      }
      const formattedDate = new Date(`${year}-${month}-${day}`);

      if (isNaN(formattedDate)) {
        const formattedDate = new Date(`${year}-${day}-${month}`);
        if (isNaN(formattedDate)) {
          return 'Invalid date';
        }
        return formattedDate.toLocaleDateString();
      }
      return formattedDate.toLocaleDateString();
    }
    return '';
  }

  function getCurrencySymbol(curr) {
    const symbols = {
      USD: '$',
      EUR: '€',
      GBP: '£',
      JPY: '¥',
      CAD: 'C$',
      AUD: 'A$',
      CHF: 'CHF',
      CNY: '¥',
      INR: '₹',
      MXN: '$',
      NZD: 'NZ$',
      SEK: 'kr',
      NOK: 'kr',
      DKK: 'kr',
      ZAR: 'R',
      BRL: 'R$',
      RUB: '₽',
      TRY: '₺',
      KRW: '₩',
      SGD: 'S$',
      HKD: 'HK$',
      MYR: 'RM',
      IDR: 'Rp',
      THB: '฿',
      PHP: '₱',
      PLN: 'zł',
      CZK: 'Kč',
      HUF: 'Ft',
      RON: 'lei',
    };
    return symbols[curr] || curr;
  }

  function formatPrice(value, curr) {
    const symbol = getCurrencySymbol(curr);

    // Special cases for currencies without decimals
    if (['JPY', 'KRW', 'VND', 'IDR'].includes(curr)) {
      return `${symbol}${Math.round(value)}`;
    }

    // For currencies with 0 decimal places
    if (['ISK', 'CLP', 'COP'].includes(curr)) {
      return `${symbol}${Math.round(value)}`;
    }

    // For currencies with 3 decimal places (like BHD, JOD, KWD)
    if (['BHD', 'JOD', 'KWD', 'OMR', 'TND'].includes(curr)) {
      return `${symbol}${value.toFixed(3)}`;
    }

    // Default: 2 decimal places
    return `${symbol}${value.toFixed(2)}`;
  }

  // Only enable the share button when we can build the emergency link.
  const hasMemberId = Boolean(
    userData?.userId || userData?.uid || getProfile()?.uid,
  );

  if (!userData) {
    return (
      <div className='payableCardContainer'>
        <b>user information not available</b>
      </div>
    );
  }
  return (
    <>
      {payable ? (
        <div className='payableCardContainer'>
          <div className='payableTopContainer'>
            <span className='payableTitle'>{'Lost card'}</span>
            <span className='payableSubTitle'>
              {userData?.cardReOrderStatus == ''
                ? 'Enjoy all the features of your World Medical Card from your wallet'
                : 'If you have lost or wish to receive an extra card then click Reorder'}
            </span>
          </div>
          <div className='purchaseSectionContainer'>
            <div className='purchaseSection'>
              <span className='purchasePrice'>{`${
                userExist ? (
                  'Free'
                ) : loadingPrice ? (
                  <CircularProgress size={14} color={'inherit'} />
                ) : (
                  formatPrice(amount, currency)
                )
              } `}</span>
              <button
                className='purchaseButton'
                disabled={userData?.cardOrderStatus == '' ? true : false}
                onClick={onReOrderPress}
              >
                {loading ? (
                  <CircularProgress size={18} color={'inherit'} />
                ) : (
                  <span>{`Reorder`}</span>
                )}
              </button>
            </div>
          </div>
        </div>
      ) : userData?.cardOrderStatus == '' ? (
        <div className='payableCardContainer'>
          <div className='payableTopContainer'>
            <span className='payableTitle'>{'Order Your Card'}</span>
            <span className='payableSubTitle'>
              {
                'Enjoy all the features of your World Medical Card from your wallet'
              }
            </span>
          </div>
          <div className='purchaseSectionContainer'>
            <div className='purchaseSection'>
              <span className='purchasePrice'>{'Free'}</span>
              <button className='purchaseButton' onClick={onOrderPress}>
                {loading ? (
                  <CircularProgress size={18} color={'inherit'} />
                ) : (
                  <span>{`Order Now`}</span>
                )}
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className='infoCardContainer'>
          <span className='infoTitle'>{`Medical Information`}</span>
          <div className='infoSectionRow'>
            <span className='infoLabel'>{`Name`}</span>
            <span className='infoValue'>{`${userData.firstName} ${userData.lastName}`}</span>
          </div>
          <div className='infoSectionRow'>
            <span className='infoLabel'>Id No.</span>
            <span className='infoValue'>{`${userData.ssn}`}</span>
          </div>
          <div className='infoSectionRow'>
            <span className='infoLabel'>DOB</span>
            <span className='infoValue'>
              {formatDateString(userData.birthDate)}
            </span>
          </div>
          <div className='infoSectionRow'>
            <span className='infoLabel'>Issued</span>
            <span className='infoValue'>
              {formatDateString(userData?.cardOrderDate)}
            </span>
          </div>

          {/* Opens the shared "Share medical data" popup */}
          <Button
            fullWidth
            variant='contained'
            startIcon={<ShareIcon />}
            disabled={!hasMemberId}
            onClick={() => onSharePress?.()}
            sx={{
              mt: 2,
              textTransform: 'none',
              fontWeight: 600,
              borderRadius: 2,
              bgcolor: '#32ABF8',
              '&:hover': { bgcolor: '#1E91D6' },
            }}
          >
            Share
          </Button>
        </div>
      )}
    </>
  );
};
